var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "language-chooser" },
    _vm._l(_vm.languages, function(language, index) {
      return _c("li", [
        _c(
          "a",
          {
            class: { active: language.active },
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.setSystemLanguage(language.id)
              }
            }
          },
          [_vm._v("\n            " + _vm._s(language.name) + "\n        ")]
        ),
        _vm._v(" "),
        index !== _vm.languages.length - 1
          ? _c("span", [_vm._v("|")])
          : _vm._e()
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1f68a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1f68a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/language-selector.vue
// module id = 935
// module chunks = 4 29 33